import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Link, useLocation } from 'react-router-dom';
import ColorModeIconDropdown from '../../theme/ColorModeIconDropdown';
import SitemarkIcon from './SitemarkIcon';
import { useAuth } from '../../context/AuthContext';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
    backdropFilter: 'blur(24px)',
    border: '1px solid',
    borderColor: (theme.vars || theme).palette.divider,
    backgroundColor: theme.vars
        ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
        : alpha(theme.palette.background.default, 0.4),
    boxShadow: (theme.vars || theme).shadows[1],
    padding: '8px 12px',
}));

export default function AppAppBar() {
    const location = useLocation();
    const [open, setOpen] = React.useState(false);
    const { logout, user } = useAuth();

    const toggleDrawer = (newOpen: boolean) => () => {
        setOpen(newOpen);
    };

    return (
        <AppBar
            position="fixed"
            enableColorOnDark
            sx={{
                boxShadow: 0,
                bgcolor: 'transparent',
                backgroundImage: 'none',
                mt: 'calc(var(--template-frame-height, 0px) + 28px)',
            }}
        >
            <Container maxWidth="lg">
                <StyledToolbar variant="dense" disableGutters>
                    <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 0 }}>
                        <SitemarkIcon />
                        <Box sx={{ display: { xs: 'none', md: 'flex', columnGap: 10 } }}>
                            {
                                user?.id &&
                               <React.Fragment>
                                 <Button href='/chat' LinkComponent='a' variant="contained" color="primary" size="small">
                                    Chat
                                </Button>
                                 {/* <Button href='/test-generator' LinkComponent='a' variant="contained" color="primary" size="small">
                                    Test Prep
                                </Button> */}
                               </React.Fragment>
                                
                            }
                            {
                                !user?.subscription &&
                                <Button href='/pricing' LinkComponent='a' variant="text" color="info" size="small">
                                    Pricing
                                </Button>
                            }
                            <Button href='/faqs' LinkComponent='a' variant="text" color="info" size="small" sx={{ minWidth: 0 }}>
                                FAQ
                            </Button>
                            {/* <Button href='/blog' LinkComponent='a' variant="text" color="info" size="small" sx={{ minWidth: 0 }}>
                                Blog
                            </Button> */}
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display: { xs: 'none', md: 'flex' },
                            gap: 1,
                            alignItems: 'center',
                        }}
                    >
                        {user?.id ? (
                            <Button onClick={logout} LinkComponent='a' color="primary" variant="text" size="small">
                                Sign Out
                            </Button>
                        ) : (
                            <Button href='/login' LinkComponent='a' color="primary" variant="text" size="small">
                                Sign in
                            </Button>
                        )}
                        {/* <Button href='/sign-up' LinkComponent='a' color="primary" variant="contained" size="small">
                            Sign up
                        </Button> */}
                        <ColorModeIconDropdown />
                    </Box>
                    <Box sx={{ display: { xs: 'flex', md: 'none' }, gap: 1 }}>
                        <ColorModeIconDropdown size="medium" />
                        <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
                            <MenuIcon />
                        </IconButton>
                        <Drawer
                            anchor="top"
                            open={open}
                            onClose={toggleDrawer(false)}
                            PaperProps={{
                                sx: {
                                    top: 'var(--template-frame-height, 0px)',
                                },
                            }}
                        >
                            <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <IconButton onClick={toggleDrawer(false)}>
                                        <CloseRoundedIcon />
                                    </IconButton>
                                </Box>
                                {
                                    user?.subscription === 'active' ? (
                                        <MenuItem component={Link} to="/chat">Chat</MenuItem>
                                    ) : (
                                        <MenuItem component={Link} to="/pricing">Pricing</MenuItem>
                                    )
                                }
                                <MenuItem component={Link} to="/faqs">FAQs</MenuItem>
                                <Divider sx={{ my: 3 }} />
                                {
                                    user?.id ? (
                                        <MenuItem>
                                            <Button onClick={logout} color="primary" variant="outlined" fullWidth>
                                                Sign Out
                                            </Button>
                                        </MenuItem>
                                    ) : (
                                        <>
                                            <MenuItem>
                                                <Button href='/login' LinkComponent='a' color="primary" variant="outlined" fullWidth>
                                                    Sign in
                                                </Button>
                                            </MenuItem>
                                        </>
                                    )
                                }
                            </Box>
                        </Drawer>
                    </Box>
                </StyledToolbar>
            </Container>
        </AppBar>
    );
}